var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7095 21.5726L16.719 19.5726C16.724 18.5117 16.2891 17.4924 15.5099 16.7389C14.7307 15.9853 13.6711 15.5593 12.5641 15.5544L5.25981 15.5226C4.15283 15.5178 3.08919 15.9346 2.30287 16.6813C1.51656 17.428 1.07198 18.4435 1.06695 19.5044L1.05745 21.5043",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9313 11.5386C11.2365 11.5486 13.1137 9.76592 13.1242 7.55681C13.1346 5.34769 11.2744 3.5487 8.96928 3.53865C6.66412 3.5286 4.78691 5.31129 4.77642 7.52041C4.76593 9.72952 6.62613 11.5285 8.9313 11.5386Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9453 8.59091L20.9168 14.5908",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0611 11.6045L17.8003 11.5772",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/userPlus.64e536c9585e446f64462bca6d701dfe.svg";
export { ForwardRef as ReactComponent };